import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { observer } from "mobx-react-lite";
import React from "react";
import type { VolunteerSubject, VolunteerTask } from "../types";
import type { VolunteerStore } from "../store";
import { SubjectGroup } from "./SubjectGroup";

interface Props {
  store: VolunteerStore;
  subject: VolunteerSubject;
  tasks: VolunteerTask[];
  isAdmin: boolean;
}

export const SortableSubjectItem = observer(({ store, subject, tasks, isAdmin }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: subject.objectId! });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <SubjectGroup
        store={store}
        subject={subject}
        tasks={tasks}
        isAdmin={isAdmin}
        dragHandleProps={{ attributes, listeners }}
      />
    </div>
  );
});
